import type { InternationalSite } from '@web-platform/shared-universal-types/src/apis/context/seoComponents';

let internationalSites: InternationalSite[] = [];

const setInternationalSites = (newInternationalSites: InternationalSite[]): void => {
  if (newInternationalSites && internationalSites.length === 0) {
    internationalSites = newInternationalSites;
  }
};

const getInternationalSites = (): InternationalSite[] => internationalSites;

export { getInternationalSites, setInternationalSites };
